export type UtilizationBasis = "MH" | "LRS" | "MH_PLUS_LRS_UNDER_LIMIT" | "MAX_MH_LRS";

export type LrsUtilizationEchoFields = {
  mhUtilization?: number;
  lrsUtilization?: number;
  lrsUtilizationUsd?: number;
  utilizationBasis?: UtilizationBasis | string;
  lrsRbiTransactionId?: string;
  lrsReportDate?: string;
  lrsUnavailable?: boolean;
  lrsMessage?: string;
};

const LRS_ECHO_KEYS: (keyof LrsUtilizationEchoFields)[] = [
  "mhUtilization",
  "lrsUtilization",
  "lrsUtilizationUsd",
  "utilizationBasis",
  "lrsRbiTransactionId",
  "lrsReportDate",
  "lrsUnavailable",
  "lrsMessage",
];

/** Echo LRS/TCS utilization fields from getTransactionSummary onto initializeTransaction. */
export function getLrsUtilizationEchoFields(summary?: any): LrsUtilizationEchoFields {
  if (!summary) return {};

  return LRS_ECHO_KEYS.reduce<LrsUtilizationEchoFields>((acc, key) => {
    const value = summary[key];
    if (value !== undefined && value !== null) {
      acc[key] = value;
    }
    return acc;
  }, {});
}
